import * as React from 'react';
import styled from "@emotion/styled";
import { Grid } from '@mui/material';

const Heading = styled.h1`
font-family: poppins;
color: #f7931a;
font-size: 70px;
margin-bottom: 10px;
font-weight:bold;
margin-top: 0px;
text-shadow: 0px 0px 50px rgba(247, 147, 26, 1);
@media (max-width: 849px) {
    font-size: 40px;
    text-align:center;
    margin-top:25px;
  }
@media (max-width: 1050px) and (min-width: 850px) {
    font-size: 55px;
    margin-top:18px;
  }
@media (min-width: 1051px) {
    margin-top:25px;
  }
`
const Container = styled(Grid)`
background-image: url('./assets/Group7564.png');
background-size: auto;
background-position: top;
padding:25px;
border-radius: 38px;
@media (max-width:  749px){
    padding:10px;
}
`
const FirstTitle = styled.p`
font-size:18px;
font-weight:900;
color:#fff;
font-family:poppins;
margin:10px 0px;
@media (max-width:  749px){
    font-size:16px;
    font-weight:600;
}
`
const SecondTitle = styled.p`
font-size:18px;
font-weight:400;
color:#fff;
font-family:poppins;
margin:10px 0px;
position: relative;
@media (max-width: 749px){
    font-size:16px;
    font-weight:600;
}
`
const Parent = styled.div`
display:flex;
padding:2px 10px;
background: rgb(12 11 11);;
border-radius: 56px;
justify-content: space-between;
margin-bottom:10px;
`
const LastParent = styled.div`
display:flex;
padding:2px 10px;
background: #f7931a;
border-radius: 56px;
justify-content: space-between;
`

function Tokenomics(){
    return (
        <div>
            <Grid>
                <Heading>Tokenomics</Heading>
                <Container>
                    <Parent>
                        <FirstTitle>Name</FirstTitle><SecondTitle>iBitcoin</SecondTitle> 
                    </Parent>
                    <Parent>
                        <FirstTitle>Symbol</FirstTitle><SecondTitle>$iBTC</SecondTitle> 
                    </Parent>
                    <Parent>
                        <FirstTitle>Supply</FirstTitle><SecondTitle>TBA</SecondTitle> 
                    </Parent>
                    <Parent>
                        <FirstTitle>Trading Fee</FirstTitle><SecondTitle>TBA</SecondTitle> 
                    </Parent>
                    <LastParent>
                        <FirstTitle>Contract</FirstTitle><SecondTitle>TBA</SecondTitle> 
                    </LastParent>
                </Container>
            </Grid>
        </div>
    );
}

export default Tokenomics;